import React from 'react';
import { createFileRoute } from '@tanstack/react-router';
import { Export } from '../../../../../../pages/project/settings/Export';
import { RoutePending } from '../../../../../../components/molecules/loader/RoutePending';
import { getProjectQuizesQueryOptions } from '../../../../../../rest-api/queries/sharedQueries';

export const Route = createFileRoute('/_private/_home/project/$project_id/settings/export')({
  loader: ({ context, params }) => {
    void context.queryClient.prefetchQuery(getProjectQuizesQueryOptions(context.apiClient, params.project_id));
  },
  component: ExportRoute,
  pendingComponent: () => <RoutePending label="Loading export settings..." />,
});

function ExportRoute() {
  const { project_id } = Route.useParams();
  const { apiClient } = Route.useRouteContext();
  return <Export projectId={project_id} portalApiClient={apiClient} />;
}
